/**
 * @description Returns new CustomEvent according to the capabilities of the browser.
 * @param {String} type
 * @param {Object} opt
 * @return {CustomEvent}
 */
export const newEvent = (
  type,
  { bubbles = false, cancelable = false, composed = false, detail = null } = {}
) => {
  if (typeof window.CustomEvent === 'function') {
    return new window.CustomEvent(type, { bubbles, cancelable, composed, detail });
  }
  const event = document.createEvent('CustomEvent');
  event.initCustomEvent(type, bubbles, cancelable, detail);
  return event;
};

export default newEvent;
